import axios from "axios"
import { sortOrders, REPLIES_LIMIT } from "@/constants/comments.js"

export const prevReplies = ({ id, cursor }) =>
  axios.get(`/api/v1/comments/${id}/replies`, {
    params: {
      after_timestamp: cursor,
      limit: REPLIES_LIMIT,
      sort_order: sortOrders.DESCENDING
    }
  })

export const nextReplies = ({ id, cursor }) =>
  axios.get(`/api/v1/comments/${id}/replies`, {
    params: {
      after_timestamp: cursor,
      limit: REPLIES_LIMIT,
      sort_order: sortOrders.ASCENDING
    }
  })

export const like = (id) => axios.post(`/api/v1/comments/${id}/like`)

export const unlike = (id) => axios.delete(`/api/v1/comments/${id}/like`)

export const get = (id) => axios.get(`/api/v1/comments/${id}`)

export const edit = (id, comment) => axios.patch(`/api/v2/comments/${id}`, comment)

export const deleteComment = (id) => axios.delete(`/api/v1/comments/${id}`)

export const report = (id, reason) => axios.post(`/api/v1/comments/${id}/reports`, { reason })

export const badges = (ids) =>
  axios.get("/api/v2/comments/badges", {
    params: {
      ids
    }
  })

export const likingUsers = ({ id, page }) =>
  axios.get(`/api/v2/comments/${id}/liking_users`, {
    params: {
      page
    }
  })
